import { render, staticRenderFns } from "./NavSidebarDrawer.vue?vue&type=template&id=b830164a&scoped=true&"
import script from "./NavSidebarDrawer.vue?vue&type=script&lang=js&"
export * from "./NavSidebarDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NavSidebarDrawer.vue?vue&type=style&index=0&id=b830164a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b830164a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
